<template>
	<footer class="app-footer" v-if="showFooter">
		<section class="contact-form-section">
			<div class="page-container">
				<form class="lead-form" @submit.prevent="onSubmit" novalidate>
					<div class="lead-form__grid">
						<div class="lead-form__field" :class="{ 'is-filled': !!form.studentName }">
							<input type="text" v-model="form.studentName" name="studentName" required @input="noop" />
							<span class="lead-form__placeholder">{{ $t('Student Name') }}<span class="lead-form__required">*</span></span>
						</div>
						<div class="lead-form__field" :class="{ 'is-filled': !!form.parentPhone }">
							<input type="text" v-model="form.parentPhone" name="parentPhone" required />
							<span class="lead-form__placeholder">{{ $t('Parent Phone') }}<span class="lead-form__required">*</span></span>
						</div>
						<div class="lead-form__field" :class="{ 'is-filled': !!form.email }">
							<input type="email" v-model="form.email" name="email" required />
							<span class="lead-form__placeholder">{{ $t('E-mail') }}<span class="lead-form__required">*</span></span>
						</div>
						<div class="lead-form__field" :class="{ 'is-filled': !!form.wechatId }">
							<input type="text" v-model="form.wechatId" name="wechatId" />
							<span class="lead-form__placeholder">{{ $t('WeChat ID') }}</span>
						</div>
						<div class="lead-form__field field-span-2" :class="{ 'is-filled': !!form.interestedCourse }">
							<input type="text" v-model="form.interestedCourse" name="interestedCourse" required />
							<span class="lead-form__placeholder">{{ $t('Interested Course') }}<span class="lead-form__required">*</span></span>
						</div>
					</div>
					<div class="lead-form__submit">
						<button type="submit" class="submit-btn" :disabled="submitting">{{ $t('Submit') }}</button>
					</div>
				</form>
			</div>
		</section>

		<div class="footer-main">
			<div class="page-container footer-main__grid">
				<div class="footer-nav-block">
					<h3>{{ $t('Panda Mandarin Project') }}</h3>
					<div class="footer-links">
						<div class="footer-links__col" v-for="(col, colIndex) in friendLinkColumns" :key="colIndex">
							<a
								v-for="item in col"
								:key="item.link + item.name"
								:href="item.link"
								:class="{ 'is-highlight': isHighlight(item) }"
							>{{ displayName(item.name) }}</a>
						</div>
					</div>
				</div>
				<div class="footer-download">
					<h3>{{ $t('Download Center') }}</h3>
					<div class="app-row" v-for="row in downloadRows" :key="row.label">
						<span class="app-label">{{ row.label }}</span>
						<div class="store-badges">
							<a class="store-badge" href="javascript:;">
								<img class="store-badge__icon" src="../assets/img/app.png" alt="App Store" />
								<span>{{ $t('Download on App Store') }}</span>
							</a>
							<a class="store-badge" href="javascript:;">
								<img class="store-badge__icon" src="../assets/img/Google.png" alt="Google Play" />
								<span>{{ $t('Download on Google Play') }}</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>


		<div class="footer-mobile" v-if="resolvedFooter || (resolvedFriendLink && resolvedFriendLink.length)">
			<div class="footer-mobile__contact" v-if="resolvedFooter">
				<div class="page-container">
					<div class="footer-logos footer-logos--mobile">
						<img class="brand-logo__img" :src="bottomLogo" alt="Panda Mandarin" />
					</div>
					<div class="footer-meta footer-meta--mobile">
						<div class="meta-item">
							<div class="meta-item__icon-container">
								<img class="meta-item__icon" src="../assets/img/xiaohongshu.png" alt="Xiaohongshu" />
								<div class="meta-label">{{ $t('Xiaohongshu ID') }}</div>
							</div>
							<div class="meta-item__content">
								<div class="meta-value">{{ resolvedFooter.book_phone }}</div>
							</div>
						</div>
						<div class="meta-item">
							<div class="meta-item__icon-container">
								<img class="meta-item__icon" src="../assets/img/phone.png" alt="" />
								<div class="meta-label">{{ $t('Contact Phone') }}</div>
							</div>
							<div class="meta-item__content">
								<div class="meta-value" v-for="phone in contactPhones" :key="'m-' + phone">{{ phone }}</div>
							</div>
						</div>
						<div class="meta-item">
							<div class="meta-item__icon-container">
								<img class="meta-item__icon" src="../assets/img/map.png" alt="" />
								<div class="meta-label">{{ $t('US Headquarters') }}</div>
							</div>
							<div class="meta-item__content">
								<div class="meta-value">{{ positionDesc }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer-mobile__download">
				<div class="page-container">
					<h3 class="footer-mobile__download-title">{{ $t('Download Center') }}</h3>
					<div class="app-row" v-for="row in downloadRows" :key="'m-' + row.label">
						<span class="app-label">{{ row.label }}</span>
						<div class="store-badges">
							<a class="store-badge" href="javascript:;">
								<img class="store-badge__icon" src="../assets/img/app.png" alt="App Store" />
								<span>{{ $t('Download on App Store') }}</span>
							</a>
							<a class="store-badge" href="javascript:;">
								<img class="store-badge__icon" src="../assets/img/Google.png" alt="Google Play" />
								<span>{{ $t('Download on Google Play') }}</span>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="footer-mobile__nav" v-if="resolvedFriendLink && resolvedFriendLink.length">
				<div class="page-container">
					<h3 class="footer-mobile__nav-title">{{ $t('Panda Mandarin Project') }}</h3>
					<a
						v-for="item in resolvedFriendLink"
						:key="'fm-' + item.link + item.name"
						:href="item.link"
					>{{ displayName(item.name) }}</a>
				</div>
			</div>
		</div>

		<div class="footer-bottom" v-if="resolvedFooter">
			<div class="page-container footer-bottom__inner">
				<div class="footer-logos">
					<div class="brand-logo">
						<img class="brand-logo__img" :src="bottomLogo" alt="Panda Mandarin" />
					</div>
				</div>
				<div class="footer-meta">
					<div class="meta-item">
						<div class="meta-item__icon-container">
							<img class="meta-item__icon" src="../assets/img/xiaohongshu.png" alt="Xiaohongshu" />
							<div class="meta-label">{{ $t('Xiaohongshu ID') }}</div>
						</div>
						<div class="meta-item__content">
							<div class="meta-value">{{ resolvedFooter.book_phone }}</div>
						</div>
					</div>
					<div class="meta-item">
						<div class="meta-item__icon-container">
							<img class="meta-item__icon" src="../assets/img/phone.png" alt="" />
							<div class="meta-label">{{ $t('Contact Phone') }}</div>
						</div>
						<div class="meta-item__content">
							<div class="meta-value" v-for="phone in contactPhones" :key="phone">{{ phone }}</div>
						</div>
					</div>
					<div class="meta-item">
						<div class="meta-item__icon-container">
							<img class="meta-item__icon" src="../assets/img/map.png" alt="" />
							<div class="meta-label">{{ $t('US Headquarters') }}</div>
						</div>
						<div class="meta-item__content">
							<div class="meta-value">{{ positionDesc }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import { getPublicInfo, resolvePublicAssetUrl, submitStudentInfo } from '../api'
import i18n from '../locales/i18n'

export default {
	props: {
		friendLink: {
			type: Array,
			default: undefined,
		},
		footerData: {
			type: Object,
			default: undefined,
		},
	},
	data() {
		return {
			localFriendLink: [],
			localFooter: null,
			submitting: false,
			form: {
				studentName: '',
				parentPhone: '',
				email: '',
				wechatId: '',
				interestedCourse: '',
			},
		}
	},
	computed: {
		resolvedFriendLink() {
			return this.friendLink !== undefined ? this.friendLink : this.localFriendLink
		},
		resolvedFooter() {
			return this.footerData !== undefined ? this.footerData : this.localFooter
		},
		showFooter() {
			return !!(this.resolvedFooter || (this.resolvedFriendLink && this.resolvedFriendLink.length))
		},
		friendLinkColumns() {
			const list = this.resolvedFriendLink || []
			const size = Math.ceil(list.length / 3) || 1
			return [list.slice(0, size), list.slice(size, size * 2), list.slice(size * 2)]
		},
		bottomLogo() {
			return require('../assets/img/logo.png')
		},
		contactPhones() {
			const phones = this.resolvedFooter && this.resolvedFooter.contact_phone
			return Array.isArray(phones) ? phones : []
		},
		positionDesc() {
			const desc = (this.resolvedFooter && this.resolvedFooter.position_desc) || ''
			return String(desc).replace(/\r\n/g, '\n')
		},
		downloadRows() {
			return [
				{ label: this.$t('Student App') },
				{ label: this.$t('Parent App') },
			]
		},
		shouldSelfFetch() {
			return this.friendLink === undefined && this.footerData === undefined
		},
		formLang() {
			return (i18n.locale === 'en') ? 'en' : 'zh-CN'
		},
	},
	mounted() {
		if (this.shouldSelfFetch) {
			this.fetchPublicInfo()
		}
	},
	watch: {
		'$i18n.locale'() {
			if (this.shouldSelfFetch) {
				this.fetchPublicInfo()
			}
		},
	},
	methods: {
		noop() {},
		displayName(name) {
			return String(name || '').replace(/\n/g, '').trim()
		},
		isHighlight(item) {
			const name = this.displayName(item && item.name)
			return name === '课程价格' || name === 'Pricing'
		},
		async fetchPublicInfo() {
			try {
				const data = await getPublicInfo()
				this.localFriendLink = (data && data.friendLink) || []
				this.localFooter = (data && data.footer) || null
			} catch (e) {
				console.error(e)
			}
		},
		validateForm() {
			if (!this.form.studentName.trim()) {
				this.$message && this.$message.error(this.$t('Please enter student name'))
				return false
			}
			if (!this.form.parentPhone.trim()) {
				this.$message && this.$message.error(this.$t('Please enter parent phone'))
				return false
			}
			if (!this.form.email.trim()) {
				this.$message && this.$message.error(this.$t('Please enter email'))
				return false
			}
			if (!this.form.interestedCourse.trim()) {
				this.$message && this.$message.error(this.$t('Please enter interested course'))
				return false
			}
			return true
		},
		async onSubmit() {
			if (this.submitting || !this.validateForm()) return
			this.submitting = true
			try {
				await submitStudentInfo({
					...this.form,
					lang: this.formLang,
				})
				this.$message && this.$message.success(this.$t('Submit success'))
				this.form = {
					studentName: '',
					parentPhone: '',
					email: '',
					wechatId: '',
					interestedCourse: '',
				}
			} catch (e) {
				console.error(e)
				this.$message && this.$message.error((e && e.msg) || this.$t('Submit failed'))
			} finally {
				this.submitting = false
			}
		},
	},
}
</script>

<style scoped lang="less">
.app-footer {
	margin-top: auto;
	font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.page-container {
	width: 100%;
	max-width: 1200px;
	margin-left: auto;
	margin-right: auto;
	padding-left: 16px;
	padding-right: 16px;
	box-sizing: border-box;
}

.contact-form-section {
	background: #B50604;
	padding: 56px 0;
}

.lead-form__grid {
	display: grid;
	gap: 16px;
}

.lead-form__field {
	position: relative;
	width: 100%;
	margin-bottom: 16px;
}

.lead-form__field input {
	position: relative;
	z-index: 1;
	width: 100%;
	height: 52px;
	border: none;
	border-radius: 4px;
	padding: 0 12px;
	font-size: 20px;
	background: #fff;
	box-sizing: border-box;
	outline: none;
}

.lead-form__placeholder {
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	color: #666;
	font-size: 20px;
	font-weight: 400;
	line-height: 1;
	pointer-events: none;
	user-select: none;
	z-index: 2;
	transition: opacity 0.15s ease;
}

.lead-form__field.is-filled .lead-form__placeholder {
	opacity: 0;
	visibility: hidden;
}

.lead-form__required {
	color: #B50604;
	margin-left: 4px;
}

.lead-form__submit {
	display: flex;
	justify-content: center;
	margin-top: 8px;
}

.submit-btn {
	min-width: 200px;
	height: 52px;
	border-radius: 26px;
	border: none;
	background: #FFB301;
	color: #fff;
	font-size: 24px;
	font-weight: 500;
	cursor: pointer;

	&:disabled {
		opacity: 0.7;
		cursor: not-allowed;
	}

	&:hover:not(:disabled) {
		filter: brightness(1.05);
	}
}

.footer-main {
	background: #fff;
	padding: 48px 0;
	border-top: 1px solid #e8e8e8;
}

.footer-main__grid {
	display: grid;
	gap: 40px;
}

.footer-main h3,
.footer-nav-block h3 {
	margin: 0 0 20px;
	font-size: 24px;
	font-weight: 400;
	color: #000;
}

.footer-links {
	display: flex;
	gap: 48px;
}

.footer-links__col {
	display: flex;
	flex-direction: column;
	gap: 12px;

	a {
		font-size: 18px;
		font-weight: 400;
		color: #000;
		text-decoration: none;

		&:hover,
		&.is-highlight {
			color: #B50604;
		}
	}
}

.footer-download .app-row {
	display: flex;
	align-items: center;
	gap: 24px;
	margin-bottom: 24px;

	&:last-child {
		margin-bottom: 0;
	}
}

.footer-download .app-label {
	min-width: 88px;
	font-size: 20px;
	font-weight: 400;
	color: #000;
}

.footer-download .store-badges {
	display: flex;
	gap: 12px;
	flex-wrap: wrap;
}

.footer-download .store-badge {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	width: 260px;
	height: 60px;
	padding: 0 16px;
	background: #fff;
	font-size: 20px;
	font-weight: 400;
	border: 1px solid #B50604;
	border-radius: 8px;
	color: #3d3d3d;
	text-decoration: none;
	box-sizing: border-box;
}

.footer-download .store-badge__icon {
	width: 32px;
	height: 40px;
	flex-shrink: 0;
	object-fit: contain;
}

.footer-bottom {
	background: #f6f6f6;
	padding: 32px 0 0;
}

.footer-bottom__inner {
	display: flex;
	flex-direction: column;
	gap: 60px;
}

.footer-logos .brand-logo__img {
	width: 133px;
	height: 100px;
	object-fit: contain;
}

.footer-meta {
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.meta-item {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 20px;
	max-width: 320px;
}

.meta-item__icon-container {
	display: flex;
	align-items: center;
	gap: 10px;
}

.meta-item__icon {
	width: 32px;
	height: 32px;
	flex-shrink: 0;
	object-fit: contain;
}

.meta-item__icon--xhs {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: #ff2442;
	color: #fff;
	font-size: 12px;
	font-weight: 700;
	border-radius: 6px;
}

.meta-item__icon-el {
	font-size: 28px;
	color: #B50604;
	width: 32px;
	text-align: center;
}

.meta-label {
	font-size: 18px;
	font-weight: 500;
	color: #1a3a6e;
	line-height: 1.3;
}

.meta-value {
	font-size: 18px;
	font-weight: 500;
	color: #000;
	line-height: 1.5;
	white-space: pre-line;
}


@media screen and (min-width: @device) {
	.lead-form__grid {
		grid-template-columns: repeat(3, 1fr);
	}

	.lead-form__grid .field-span-2 {
		grid-column: span 2;
	}

	.footer-main__grid {
		grid-template-columns: 1fr 1fr;
		align-items: start;
		gap: 80px;
	}

	.footer-bottom__inner {
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
		padding-bottom: 32px;
	}

	.footer-meta {
		flex-direction: row;
		align-items: flex-start;
		gap: 120px;
	}
}

@media screen and (max-width: @device) {
	.contact-form-section {
		padding: 32px 0;
	}

	.lead-form__field {
		margin-bottom: 12px;
	}

	.lead-form__field input {
		height: 44px;
		border-radius: 8px;
		font-size: 16px;
	}

	.lead-form__placeholder {
		font-size: 16px;
	}

	.submit-btn {
		width: 200px;
		height: 40px;
		border-radius: 20px;
		font-size: 18px;
	}

	.footer-main h3 {
		font-size: 20px;
	}

	.footer-links {
		gap: 24px;
		flex-wrap: wrap;
	}

	.footer-links__col a {
		font-size: 15px;
	}

	.footer-download .app-row {
		flex-direction: column;
		align-items: flex-start;
		gap: 12px;
	}

	.footer-download .app-label {
		font-size: 16px;
	}

	.footer-download .store-badge {
		width: 100%;
		max-width: 260px;
		height: 48px;
		font-size: 14px;
	}

	.footer-meta {
		align-items: center;
		text-align: center;
	}

	.meta-item {
		align-items: center;
		max-width: none;
	}

	.meta-item__icon-container {
		justify-content: center;
	}
}

.footer-mobile {
  display: none;
}

@media screen and (max-width: 767px) {
  .footer-main {
    display: none !important;
  }

  .footer-bottom__inner {
    display: none !important;
  }

  .footer-bottom {
    background: #fff;
    padding: 0;
  }

  .footer-mobile {
    display: block;
  }

  .footer-mobile__contact {
    background: #f6f6f6;
    padding: 2rem 1rem;
    text-align: center;
  }

  .footer-logos--mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .footer-logos--mobile .brand-logo__img {
    width: 8.3125rem;
    height: 6.25rem;
    object-fit: contain;
  }

  .footer-meta--mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }

  .footer-meta--mobile .meta-item {
    align-items: center;
    text-align: center;
    gap: 0.5rem;
    max-width: 100%;
  }

  .footer-meta--mobile .meta-item__icon-container {
    justify-content: center;
  }

  .footer-meta--mobile .meta-item__content {
    width: 100%;
  }

  .footer-meta--mobile .meta-item__content .meta-value {
    color: #333;
    font-size: 1.25rem;
    white-space: pre-line;
  }

  .footer-mobile__download {
    background: #fff;
    padding: 2rem 1rem;
    text-align: center;
  }

  .footer-mobile__download-title {
    margin: 0 0 1.5rem;
    font-size: 1.25rem;
    font-weight: 400;
    color: #000;
  }

  .footer-mobile__download .app-row {
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
  }

  .footer-mobile__download .app-row:last-child {
    margin-bottom: 0;
  }

  .footer-mobile__download .app-label {
    font-size: 1rem;
  }

  .footer-mobile__download .store-badges {
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    margin-top: 0.75rem;
  }

  .footer-mobile__download .store-badge {
    width: 16.25rem;
    max-width: 100%;
    height: 3.75rem;
    justify-content: flex-start;
    border: 0.0625rem solid #B50604;
    display: flex;
    padding: 0.5625rem 1rem;
    align-items: center;
    gap: 0.5rem;
    border-radius: 0.25rem;
    margin: 0.75rem auto;
    font-size: 1.25rem;
    box-sizing: border-box;
    text-decoration: none;
    color: #000;
  }

  .footer-mobile__download .store-badge__icon {
    width: 2rem;
    height: 2.5rem;
    object-fit: contain;
  }

  .footer-mobile__nav {
    background: #f6f6f6;
    padding: 2rem 1rem;
    text-align: center;
  }

  .footer-mobile__nav-title {
    margin: 0 0 1rem;
    font-size: 1.25rem;
    font-weight: 400;
    color: #000;
  }

  .footer-mobile__nav a {
    display: block;
    padding: 0.625rem 0;
    font-size: 1rem;
    font-weight: 400;
    color: #000;
    text-decoration: none;
  }

  .footer-mobile__nav a:hover {
    color: #B50604;
  }

}

@media screen and (min-width: 768px) {
  .footer-mobile {
    display: none !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/WpFooter.vue